var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"financial-warning"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"ml-1",attrs:{"color":"warning"}},on),[_vm._v("\n\t\t\t\twarning\n\t\t\t")])]}}])},[_c('span',[_vm._v("Faktycznie poniesione wydatki są większe niż kwota z umowy")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }